import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Icon } from 'antd';
import { connect } from 'react-redux';
const styles = {
  modalClass: {
    '& .ant-modal-body': {
      padding: '24px 0px 0px 0px',
      borderRadius: '5px',
    },
    '& .ant-modal-close-x': {
      marginRight: '-12px',
      marginTop: '-12px',
    },
  },
};
class SEAddTaskProtip extends React.PureComponent<any, any> {
  render() {
    const { classes, handleClose, handleSubmit } = this.props;
    return <Modal
      closable={true}
      className={classes.modalClass}
      width={390}
      onCancel={handleSubmit}
      visible={this.props.visible}
      footer={null}>
      <div style={{
        height: 140, display: 'flex', flexDirection: 'column', textAlign: 'center',
      }}>
          <div style={{
            paddingLeft: '24px', paddingRight: '24px', height: '50%',
            color: '#424242', fontFamily: 'Open Sans',
            fontSize: '14px', lineHeight: '19px', marginTop: '4%',
          }}>
            <Icon type="check-circle" theme="filled"
              style={{ color: '#52C41A', fontSize: '20px',
                marginRight: '10px',
              }} />
            Task created successfully.
          </div>
        <div style={{
          height: '50%', borderBottomRightRadius: '5px',
          backgroundColor: '#FFF5B7', borderBottomLeftRadius: '5px',
          cursor: 'pointer',
        }} onClick={handleSubmit}>
          <div style={{ padding: '20px 22px 0px 24px' }}>
            <Icon type="bulb" /> Update the status of the task as you progress.
          </div>
        </div>
      </div>
    </Modal>;
  }
}

export default injectSheet(styles)(SEAddTaskProtip);
